import api from './client';

export const fetchFeatureAccessOverview = () =>
  api.get('/admin/feature_access_overview');
